import React from 'react';

const OrdenarHero = () => {
  return(
    <>
      <a href="#opciones" className='btn-hero-izq'>Ordenar Ahora</a>
    </>
  )
}

export { OrdenarHero }